// const url = 'https://demohris.klinikjoydental.com/'
const url = 'https://jdhris.my.id/'

export const urlApi = () => {
    const url_api = `${url}apirekrutmen/`
    return url_api
}

export const urlBase = () => {
    const url_api = url
    return url_api
}